import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventList: true,
  photoUpload: {},
  shareModalTri: false,
  reindexFace: {},
};
const apiTriggerSlice = createSlice({
  name: "apiTrigger",
  initialState,
  reducers: {
    eventListTrigger: (state, action) => {
      state.eventList = !state.eventList;
    },
    photoUploadTrigger: (state, action) => {
      state.photoUpload = {
        ...state.photoUpload,
        [action.payload.id]: action.payload.value,
      };
    },
    reindexFaceTrigger: (state, action) => {
      state.reindexFace = {
        ...state.reindexFace,
        [action.payload.id]: action.payload.value,
      };
    },
    shareModalTrigger: (state, action) => {
      state.shareModalTri = !state.shareModalTri;
    },
  },
});

export const {
  eventListTrigger,
  photoUploadTrigger,
  shareModalTrigger,
  reindexFaceTrigger,
} = apiTriggerSlice.actions;
export default apiTriggerSlice;
